<template>
  <v-card class="card--shadow">
    <v-card-title class="purple accent-4">
      <div class="subtitle-1 white--text">FO Form</div>
    </v-card-title>
    <v-card-text class="pt-4">
      <form-require-noti />
      <label>Name <require-sign /></label>
      <v-text-field
        v-model.trim="pa.name"
        :error-messages="handleFieldErrors($v.pa.name)"
        type="text"
        outlined
        dense
      ></v-text-field>
      <label>Township <require-sign /></label>
      <v-combobox
        v-model="pa.township"
        :error-messages="handleFieldErrors($v.pa.township)"
        outlined
        dense
        item-text="name"
        item-value="id"
        :items="townships"
      ></v-combobox>
    </v-card-text>

    <v-card-actions class="px-4 pb-4">
      <v-spacer></v-spacer>
      <v-btn v-if="pa.id" @click.prevent="emitPaData" class="form-btn">
        Update
      </v-btn>
      <v-btn v-else @click.prevent="emitPaData" class="form-btn">
        Submit
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { ValidationMixin } from "./../../mixins/ValidationMixin";
import { mapState } from "vuex";
import FormRequireNoti from "../notification/FormRequireNoti.vue";
import RequireSign from "@/components/notification/RequireSign.vue";

export default {
  components: { FormRequireNoti, RequireSign },
  mixins: [ValidationMixin],
  props: {
    pa: {
      type: Object,
      default: () => {
        return {
          name: null,
          township: null,
        };
      },
    },
  },
  data: () => ({}),
  validations: {
    pa: {
      name: {
        required,
      },
      township: {
        required,
      },
    },
  },
  computed: {
    ...mapState("Loading", ["loading"]),
    ...mapState("Township", ["townships"]),
    nameErrors() {
      return this.handleFieldErrors(this.$v.pa.name);
    },
    townshipErrors() {
      return this.handleFieldErrors(this.$v.pa.township);
    },
  },
  methods: {
    emitPaData() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let data = {
          name: this.pa.name,
          township_id: this.pa.township.id,
        };

        this.pa.id ? (data.id = this.pa.id) : false;

        this.$emit("emitPaData", data);

        this.pa.name = null;
        this.$v.$reset();
      }
    },
  },
  created() {
    this.$store.dispatch("Township/getTownships");
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
